import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '@/requests/workspaces/constants';
import { workspaceActions, workspaceFormActions } from '../constants';

const useFetchWorkspaceForm = (fn, category, code, readStatus, intl) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fn(category, code, intl);
    }
  }, []);
};

export default {
  useFetchWorkspaceForm,
  useFetchFormForWorkspaceRequest: ({ code, intl }, readStatus) => fetch.useFetchDispatch(
    actions.FETCH_FORM_FOR_WORKSPACE_REQUEST,
    readStatus,
    { code, intl },
  ),
  useNewWorkspaceRequest: ({ code, form }, readStatus) => fetch.useFetchDispatch(
    workspaceActions.NEW_WORKSPACE_REQUEST,
    readStatus,
    { code, form },
  ),
  useWorkspaceFormHealthCheck: ({ code, source }, readStatus) => fetch.useFetchDispatch(
    workspaceFormActions.HEALTH_WORKSPACE_FORM,
    states.NONE,
    { code, source },
    fetchConfig([], () => readStatus !== states.PENDING),
  ),
};
